import * as React from "react";
import Component from "../../AbstractComponent";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Payment2DetailsEditable from "../Payment/Payment2DetailsEditable";
import Time from "../../../Time/Time";
import Constants from "../../../Action/Constants";
import { Company } from "../../../Entity/Entities/Company/Company";
import { Person } from "../../../Entity/Entities/Person/Person";
import { PaymentInterface } from "../../../Entity/Entities/Payment/PaymentInterface";
import { connect } from "react-redux";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import PaymentTypeContainer from "../../../Entity/Entities/Payment/PaymentType/PaymentTypeContainer";

interface StateInterface {
  newPayment: any;
  isSaving: boolean;
}

class PaymentCreateDialog extends Component {
  public paymentDetails;

  public state: StateInterface = {
    newPayment: {},
    isSaving: false
  };

  constructor(public props) {
    super(props);

    this.paymentDetails = React.createRef();
  }

  public onCancel = (): any => {
    this.setState({
      isSaving: false
    }, () => {
      this.props.dispatch({
        type: Constants.GLOBAL_PAYMENT_CREATE_CLEAR
      });
  
      if (typeof this.props.onCancel === "function") {
        this.props.onCancel.call(this);
      }
    })
  }

  public onSave = (): any => {
    this.paymentDetails?.current?.updateParentState(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_PAYMENT_CREATE_CLEAR
      });

      const payment: any = {
        amount: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.newPayment?.amountForPayment)).replace(",", ".")).toFixed(2)),
        currencyId: this.state.newPayment?.currencyIdForPayment,
        firstDateOfStatementPeriod: Time.formatOrNull(this.state.newPayment?.firstDateOfStatementPeriodForPayment),
        dateOfThePayment: Time.formatOrNull(this.state.newPayment?.dateOfThePayment),
        paymentTypeId: Number(this.state.newPayment?.typeIdForPayment),
        agencyBankAccount: Number(this.state.newPayment?.typeIdForPayment) === PaymentTypeContainer.pickIdFromLabel("Bank") ? this.state.newPayment?.agencyBankAccountIdForPayment : null,
        paymentClassId: Number(this.state.newPayment?.paymentClassId),
        description: this.state.newPayment?.descriptionForPayment
      };

      if (this.state.newPayment?.selectedCounterpartyForPayment instanceof Person) {
        payment.contactId = this.state.newPayment?.selectedCounterpartyForPayment?.id;
      }

      if (this.state.newPayment?.selectedCounterpartyForPayment instanceof Company) {
        payment.companyId = this.state.newPayment?.selectedCounterpartyForPayment?.id;
      }
  
      return this.saving(() => {
        this.props.dispatch({
          type: Constants.GLOBAL_PAYMENT_CREATE_START,
          payload: {
            payment: payment
          },
          onSuccess: (payment: PaymentInterface) => {
            this.props.dispatch({
              type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
            });

            this.onCancel();
  
            return this.redirect(`/app/payment/update/${payment.id}`);
          },
          onError: () => {
            return this.setState({
              hasModifiedData: true,
              isSaving: false
            });
          }
        });
      });
    });
  }

  public render() {
    return (
      <Dialog
        className={`dialog dialog-window has-button-padding ${this.props.innerDialogClasses ? this.props.innerDialogClasses : ""}`}
        open={this.props.isOpened}
        onClose={this.onCancel}
        disableBackdropClick={true}
      >
        <DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              minHeight: "calc(24px + 2em)"
          }}>
            <div>
              <h4 style={{
                  margin: "15px 0 0 0",
                  padding: this.props.subtitle ? "20px 0 0 0" : "20px 0"
                }}
                >
                {this.props.title}
              </h4>
              {
                this.props.subtitle && (
                <div
                  style={{
                    fontSize: "13px",
                    paddingBottom: "9px",
                    fontWeight: "normal",
                    color: "rgb(137, 137, 137)",
                    margin: 0
                  }}
                  >{this.props.subtitle}</div>
                )
              }
            </div>
          </div>
        </DialogTitle>

        <DialogContent>
          <div style={{padding: "20px"}}>
            <Payment2DetailsEditable
              {...this.props} 
              ref={this.paymentDetails}
              dialogPresentation={true}
              updateState={(newPaymentState, callback?) => {
                this.setState({
                  newPayment: {
                    ...newPaymentState
                  }
                }, () => {
                  if (typeof callback === "function") {
                    callback();
                  }
                })
              }}
            />
          </div>
        </DialogContent>

        <div className="dialog-buttons-wrapper">
          <DialogActions>
            <Button
              color="primary"
              onClick={this.onCancel}
            >
              {this.trans("dialog-button/cancel")}
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={this.onSave}
            >
              {this.trans("dialog-button/create")}
            </Button>
          </DialogActions>
        </div>

        <PageTransition isSaving={this.state.isSaving} />
      </Dialog>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    events: state.events,
    tasks: state.tasks,
    component: state.paymentCreateDialog,
    globalTypes: state.globalTypes,
    properties: state.properties,
    units: state.units
  };
};

export default connect(mapStateToProps)(
  PaymentCreateDialog
);
